/**
 * Auto-generated service - DO NOT EDIT MANUALLY
 * Generated from: policy.ts
 * Run: pnpm gen
 */

import { API_METHODS } from '../constants/api-methods';
import { getApiPath } from '../path';
import { type RequestOptions, type Transport } from '../transport';

import type {
  AddPolicyRuleRequest,
  AddPolicyRuleResponse,
  ClonePolicyRequest,
  ClonePolicyResponse,
  CreatePolicyRequest,
  CreatePolicyResponse,
  GetPolicyRequest,
  GetPolicyResponse,
  ListPoliciesByProgramRequest,
  ListPoliciesByProgramResponse,
  RemovePolicyRuleRequest,
  RemovePolicyRuleResponse,
  UpdatePolicyRequest,
  UpdatePolicyResponse,
} from '../types/policy';

export const createPolicyService = (transport: Transport) => ({
  async createPolicy(
    request: CreatePolicyRequest,
    options: RequestOptions = {},
  ): Promise<CreatePolicyResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.PolicyService.CreatePolicy, { organization_id, program_id });
    return transport.post<CreatePolicyResponse>(url, body, options);
  },

  async clonePolicy(
    request: ClonePolicyRequest,
    options: RequestOptions = {},
  ): Promise<ClonePolicyResponse> {
    const { organization_id, program_id, ...body } = request;
    const url = getApiPath(API_METHODS.PolicyService.ClonePolicy, { organization_id, program_id });
    return transport.post<ClonePolicyResponse>(url, body, options);
  },

  async getPolicy(
    request: GetPolicyRequest,
    options: RequestOptions = {},
  ): Promise<GetPolicyResponse> {
    const { organization_id, program_id, policy_id } = request;
    const url = getApiPath(API_METHODS.PolicyService.GetPolicy, {
      organization_id,
      program_id,
      policy_id,
    });
    return transport.get<GetPolicyResponse>(url, options);
  },

  async updatePolicy(
    request: UpdatePolicyRequest,
    options: RequestOptions = {},
  ): Promise<UpdatePolicyResponse> {
    const { organization_id, program_id, policy_id, ...body } = request;
    const url = getApiPath(API_METHODS.PolicyService.UpdatePolicy, {
      organization_id,
      program_id,
      policy_id,
    });
    return transport.post<UpdatePolicyResponse>(url, body, options);
  },

  async addPolicyRule(
    request: AddPolicyRuleRequest,
    options: RequestOptions = {},
  ): Promise<AddPolicyRuleResponse> {
    const { organization_id, program_id, policy_id, ...body } = request;
    const url = getApiPath(API_METHODS.PolicyService.AddPolicyRule, {
      organization_id,
      program_id,
      policy_id,
    });
    return transport.post<AddPolicyRuleResponse>(url, body, options);
  },

  async removePolicyRule(
    request: RemovePolicyRuleRequest,
    options: RequestOptions = {},
  ): Promise<RemovePolicyRuleResponse> {
    const { organization_id, program_id, policy_id, rule_name } = request;
    const url = getApiPath(API_METHODS.PolicyService.RemovePolicyRule, {
      organization_id,
      program_id,
      policy_id,
      rule_name,
    });
    return transport.delete<RemovePolicyRuleResponse>(url, options);
  },

  async listPoliciesByProgram(
    request: ListPoliciesByProgramRequest,
    options: RequestOptions = {},
  ): Promise<ListPoliciesByProgramResponse> {
    const { organization_id, program_id, ...params } = request;
    const url = getApiPath(API_METHODS.PolicyService.ListPoliciesByProgram, {
      organization_id,
      program_id,
    });
    return transport.get<ListPoliciesByProgramResponse>(url, { params, ...options });
  },
});

export type PolicyService = ReturnType<typeof createPolicyService>;
